// extracted by mini-css-extract-plugin
export default {"brandPromo":"cF-z","carousel":"dF-z"};